module.exports = __webpack_public_path__ + "static/media/logo-oh-small.d47bbbc2.png";